var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filters"},[_c('v-row',_vm._l((_vm.items),function(item,idx){return _c('v-col',{key:idx,attrs:{"cols":item.cols}},[_c(item.component,_vm._b({tag:"component",attrs:{"value":item.initialValue},on:{"input":function($event){return _vm.onInput(item, $event)}}},'component',item.componentProps,false))],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }